import {
  defaultBaseQuery,
  transformErrorResponse,
  transformSuccessResponse,
} from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const divisionConfigurationAPI = createApi({
  reducerPath: "divisionConfigurationAPI",
  baseQuery: defaultBaseQuery,
  tagTypes: ["Configuration"],
  endpoints: (builder) => ({
    getDivisionConfigurationList: builder.query({
      query: (params) => ({
        url: `/configuration`,
        method: "GET",
        params,
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
      providesTags: ["Configuration"],
    }),
    saveDivisionConfiguration: builder.mutation({
      query: (body) => ({
        url: `/configuration`,
        method: "POST",
        body,
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
      invalidatesTags: ["Configuration"],
    }),
    getDivisionConfigurationDetails: builder.query({
      query: (params) => ({
        url: `/configuration/details`,
        method: "GET",
        params,
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),
    getDivisionConfigurationByProgramBranch: builder.query({
      query: (params) => ({
        url: `/configuration`,
        method: "GET",
        params,
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),
    updateDivisionConfiguration: builder.mutation({
      query: (body) => ({
        url: `/configuration`,
        method: "PUT",
        body,
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
      invalidatesTags: ["Configuration"],
    }),
    deleteDivisionConfigurationItem: builder.mutation({
      query: (id) => ({
        url: `/configuration/${id}`,
        method: "DELETE",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
      invalidatesTags: ["Configuration"],
    }),
  }),
});

export const {
  useGetDivisionConfigurationListQuery,
  useSaveDivisionConfigurationMutation,
  useLazyGetDivisionConfigurationDetailsQuery,
  useLazyGetDivisionConfigurationByProgramBranchQuery,
  useUpdateDivisionConfigurationMutation,
  useDeleteDivisionConfigurationItemMutation,
} = divisionConfigurationAPI;

export default divisionConfigurationAPI;
